<script>
    import user from '../state/user';

    export let clnId;
    export let code;

    let submitting = false;

    let message = {
        contents: '',
        isError: false
    };

    function onLoad() {
        user.verify(clnId, code).then((res) => {
            message.isError = !res;

            if (res) {

                if (res.status) {
                    message.contents = 'Účet byl ověřen a byli jste přihlášeni, přesměrovávám na rezervační systém ...';
                } else {
                    message.contents = 'Tento účet již byl ověřen, přesměrovávám na rezervační systém ...';
                }

                // Redirect
                setTimeout(() => {
                    location.href = '/';
                }, 5000);
            } else {
                message.contents = 'Účet se nepodařilo ověřit';
            }
        });
    }

    // Check client and code
    onLoad();
</script>

<div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <div class="modal-card-title">
                Ověření účtu
            </div>
        </header>
        <section class="modal-card-body">
            {#if message.contents && message.contents.length}
                <div class="notification is-danger" class:is-danger={message.isError} class:is-info={!message.isError}>
                    {message.contents}
                </div>
            {:else}
                <div class="notification is-info">
                    Probíhá ověřování účtu ...
                </div>
            {/if}
        </section>

        <footer class="modal-card-foot"></footer>
    </div>
</div>